import { motion } from 'framer-motion';
import styles from './Loader.module.css';
import mLogo from '../../assets/m_logo.png';

const Loader = () => {
  return (
    <div className={styles.loaderContainer}>
      <motion.img
        src={mLogo}
        alt="Loading"
        className={styles.loaderLogo}
        animate={{
          scale: [1, 1.2, 1],
          opacity: [0.7, 1, 0.7],
        }}
        transition={{
          duration: 1.5,
          repeat: Infinity,
          ease: 'easeInOut',
        }}
      />
    </div>
  );
};

export default Loader;
